import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstance, { microServices } from 'network/apis'

const PREDICTION_MARKET_BASE_PATH = '/prediction-market'

export const getTradingFeeReportService = (params) => axiosInstance(
  METHOD_TYPES.get, `${PREDICTION_MARKET_BASE_PATH}/trading-fee-report`, {},
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.table, params }
)

export const getPredictionMarketDashboardService = (params) => axiosInstance(
  METHOD_TYPES.get, `${PREDICTION_MARKET_BASE_PATH}/prediction-market-dashboard`, {},
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.page, params }
)

export const getMarketsService = (params) => axiosInstance(
  METHOD_TYPES.get,
  `${PREDICTION_MARKET_BASE_PATH}/get-markets`,
  {},
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.table, params }
)

export const getQuestionDetailsService = (params) => axiosInstance(
  METHOD_TYPES.get,
  `${PREDICTION_MARKET_BASE_PATH}/get-question-details`,
  {},
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.table, params }
)

export const getCategoriesService = (params) => axiosInstance(
  METHOD_TYPES.get,
  `${PREDICTION_MARKET_BASE_PATH}/get-categories`,
  {},
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.table, params }
)

export const updateCategoryStatusService = (data) => axiosInstance(
  METHOD_TYPES.post,
  `${PREDICTION_MARKET_BASE_PATH}/set-category-active`,
  data,
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.submit, successMessage: 'Category updated' }
)

export const createCategoryService = (data) => axiosInstance(
  METHOD_TYPES.post,
  `${PREDICTION_MARKET_BASE_PATH}/create-category`,
  data,
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.submit, successMessage: 'Category created' }
)

export const createQuestionService = (data) => axiosInstance(
  METHOD_TYPES.post,
  `${PREDICTION_MARKET_BASE_PATH}/create-question`,
  data,
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.submit, successMessage: 'Question created successfully' }
)

export const editQuestionService = (data) => axiosInstance(
  METHOD_TYPES.put,
  `${PREDICTION_MARKET_BASE_PATH}/edit-question`,
  data,
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.submit, successMessage: 'Question updated successfully' }
)

export const editOptionService = (data) => axiosInstance(
  METHOD_TYPES.put,
  `${PREDICTION_MARKET_BASE_PATH}/edit-option`,
  data,
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.submit, successMessage: 'Option updated successfully' }
)

export const closeQuestionService = (data) => axiosInstance(
  METHOD_TYPES.post,
  `${PREDICTION_MARKET_BASE_PATH}/close-question`,
  data,
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.submit, successMessage: 'Question closed successfully' }
)

export const promoteToBreakingService = (data) => axiosInstance(
  METHOD_TYPES.post,
  `${PREDICTION_MARKET_BASE_PATH}/promote-to-breaking`,
  data,
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.submit, successMessage: 'Market promoted to breaking' }
)

export const removeFromBreakingService = (data) => axiosInstance(
  METHOD_TYPES.post,
  `${PREDICTION_MARKET_BASE_PATH}/remove-from-breaking`,
  data,
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.submit, successMessage: 'Market removed from breaking' }
)

export const addOptionsService = (data) => axiosInstance(
  METHOD_TYPES.post,
  `${PREDICTION_MARKET_BASE_PATH}/add-options`,
  data,
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.submit, successMessage: 'Option added successfully' }
)

export const updateOptionStateService = (data) => axiosInstance(
  METHOD_TYPES.post,
  `${PREDICTION_MARKET_BASE_PATH}/update-option-state`,
  data,
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.submit, successMessage: 'Option state updated successfully' }
)

export const getRecentTradesService = (params) => axiosInstance(
  METHOD_TYPES.get,
  `${PREDICTION_MARKET_BASE_PATH}/get-recent-trades`,
  {},
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.table, params }
)

export const getTopHoldersService = (params) => axiosInstance(
  METHOD_TYPES.get,
  `${PREDICTION_MARKET_BASE_PATH}/get-top-holders`,
  {},
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.table, params }
)

export const getTradeSummaryService = (params) => axiosInstance(
  METHOD_TYPES.get,
  `${PREDICTION_MARKET_BASE_PATH}/get-trade-summary`,
  {},
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.table, params }
)

export const getQuestionSummaryService = (params) => axiosInstance(
  METHOD_TYPES.get,
  `${PREDICTION_MARKET_BASE_PATH}/get-question-summary`,
  {},
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.table, params }
)

export const getTranslationService = (data) => axiosInstance(
  METHOD_TYPES.post,
  `${PREDICTION_MARKET_BASE_PATH}/get-translation`,
  data,
  { server: microServices.USER_URL, loader: LOADER_HANDLER_TYPES.submit }
)

